import type { FC } from "react";

import { cn } from "@/ui/lib/utils";
import { TActionHeroProps } from "@/ui/components/sections/hero/ActionHero";
import { Section } from "@/ui/components/layout/Section";
import { Grid } from "@/ui/components/layout/Grid";
import { Column } from "@/ui/components/layout/Column";
import { AspectRatio } from "@/ui/components/primitives/AspectRatio";
import { Image } from "@/ui/components/primitives/Image";
import { TextTitle } from "@/ui/components/typography";
import { TextSubtitle } from "@/ui/components/typography/TextSubtitle";
import { TextBody } from "@/ui/components/typography/TextBody";
import { ActionHeroCtas } from "./ActionHeroCtas";

export const ActionHero: FC<TActionHeroProps> = (
  {
    title,
    subtitle,
    body,
    image,
    ctas,
    className,
    children,
    ...props
  },
) => {

  return (
    <Section
      {...props}
      data-component="ActionHero"
      className={cn(
        className,
      )}
    >
      <Grid gap={{ default: "5", xl: "8" }}>
        <Column>
          <TextTitle size={3}>{ title }</TextTitle>
        </Column>
        <Column>
          <Grid>
            <Column spans={{ xl: "6" }} className="order-first xl:order-last">
              <AspectRatio ratio={{ default: "21:9", xl: "1.6:1" }}>
                <Image {...image} fit="cover" />
              </AspectRatio>
            </Column>
            <Column spans={{ xl: "6" }} className="order-first xl:order-first flex flex-col xl:justify-between space-y-4">
              <Grid gap={{ default: "2", xl: "4" }}>
                { subtitle ? (
                  <Column>
                    <TextSubtitle size={2}>{ subtitle }</TextSubtitle>
                  </Column>
                ): null }
                <Column>
                  <TextBody size={1}>{ body }</TextBody>
                </Column>
              </Grid>
              <ActionHeroCtas ctas={ctas} />
            </Column>
          </Grid>
        </Column>
      </Grid>
      { children }
    </Section>
  );
};

ActionHero.displayName = "ActionHero";
